import { render, staticRenderFns } from "./UpsDetails.vue?vue&type=template&id=5341a2cd&"
import script from "./UpsDetails.vue?vue&type=script&lang=js&"
export * from "./UpsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports